/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserQueryResultOrg model module.
 * @module model/UserQueryResultOrg
 * @version 1.0
 */
class UserQueryResultOrg {
    /**
     * Constructs a new <code>UserQueryResultOrg</code>.
     * @alias module:model/UserQueryResultOrg
     */
    constructor() { 
        
        UserQueryResultOrg.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserQueryResultOrg</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserQueryResultOrg} obj Optional instance to populate.
     * @return {module:model/UserQueryResultOrg} The populated <code>UserQueryResultOrg</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserQueryResultOrg();

            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} createdAt
 */
UserQueryResultOrg.prototype['createdAt'] = undefined;

/**
 * @member {String} deletedAt
 */
UserQueryResultOrg.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
UserQueryResultOrg.prototype['id'] = undefined;

/**
 * @member {String} name
 */
UserQueryResultOrg.prototype['name'] = undefined;

/**
 * @member {String} updatedAt
 */
UserQueryResultOrg.prototype['updatedAt'] = undefined;






export default UserQueryResultOrg;

